import { Component, Input, OnChanges, SimpleChanges, Inject, ViewChild, TemplateRef } from '@angular/core';
import { OrderItemListService } from 'dm-src/app/modules/shared/list/order-items-list/order-item-list.service';
import {
  OrderItemState,
  OrderReturnControlService,
  ColorClass,
  FlashMessageService,
  StartOrderReturn, OrderItem, UserRole, AUTH_SERVICE_IMPL, IAuthenticationService,
} from 'shared';
import { OrderReturnItemDto } from 'shared';
import { ORDER_RETURN_SERVICE_IMPL, IOrderReturnService } from 'shared';
import { OrderReturnItem } from 'shared';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IModifyOrderItem } from '../../../../../../../shared/src/lib/dtos/imodifyorderitemdto';
import { getOrderItemStateOptions } from '../../../../../../../shared/src/lib/types/order-item-state';
import { OrderItemDepositProduct } from '../../../../../../../shared/src/lib/models/order-item-deposit-product';

@Component({
    selector: 'app-order-items-list',
    templateUrl: './order-items-list.component.html',
    styleUrls: ['./order-items-list.component.scss'],
})
export class OrderItemsListComponent implements OnChanges {
    @Input() taskID: string;
    @Input() orderID: number;
    public OrderItemState = OrderItemState;

    public startOrderReturn: StartOrderReturn = {} as StartOrderReturn;
    public orderReturnItemDtoList: OrderReturnItemDto[];
    public orderReturnItemList: OrderReturnItem[];
    public orderReturnComment = '';

    public returnImgSrc: string;
    public photoLoaded: boolean;
    public returnPhotoImageContent: string;
    public returnPhotoImageExtension: string;

    canModifyOrderItem: boolean;
    @ViewChild('orderItemModifyModal', { static: false })
    private _orderItemModifyModal: TemplateRef<any>;
    public selectedOrderItemForModify: IModifyOrderItem;
    private modalRef: NgbModalRef;
    orderItemStateOptions = getOrderItemStateOptions();

    constructor(
        public orderItemListService: OrderItemListService,
        public orderReturnControlService: OrderReturnControlService,
        private _flashMessageService: FlashMessageService,
        @Inject(ORDER_RETURN_SERVICE_IMPL)
        private _orderReturnService: IOrderReturnService,
        @Inject(AUTH_SERVICE_IMPL)
        private _authService: IAuthenticationService,
        private _modalService: NgbModal
    ) {
        this.photoLoaded = false;
        this.canModifyOrderItem = this._authService.currentUser.hasRoles([UserRole.Supporter]);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.orderItemListService.getOrderItems(this.taskID, this.orderID);
        this.orderItemListService.getOriginalOrderWeight(this.orderID);
        this.orderItemListService.setReturnInProgress(false);
        this.orderReturnControlService.OrderReturnItemList.subscribe(
            (OrderReturnItemList) => (this.orderReturnItemDtoList = OrderReturnItemList)
        );
    }

    startReturnProgress(): void {
        this.orderItemListService.setReturnInProgress(true);
    }

    addReturnRequest(): void {
        if (this.orderReturnItemDtoList.length == 0) {
            this._flashMessageService.showMessage(
                'common.error',
                'order-return.select-return-items-message',
                5000,
                ColorClass.Danger,
                'order-details-modal'
            );
            return;
        }

        this.startOrderReturn.comment = this.orderReturnComment;
        this.startOrderReturn.orderID = this.orderID;
        this.startOrderReturn.orderReturnItemDtoList = this.orderReturnItemDtoList;
        this.startOrderReturn.orderReturnImageContent = this.returnPhotoImageContent;
        this.startOrderReturn.orderReturnImageExtension = this.returnPhotoImageExtension;

        this._orderReturnService
            .startReturnOrderItems(this.startOrderReturn)
            .subscribe((startReturn) => {
                this.orderReturnItemList = startReturn.body;
                this.refreshOrderItemList();

                this._flashMessageService.showMessage(
                    'common.success',
                    'order-return.return-started-message',
                    5000,
                    ColorClass.Success,
                    'order-details-modal'
                );
            });
    }

    refreshOrderItemList(): void {
        this.orderItemListService.getOrderItems(this.taskID, this.orderID);
        this.orderItemListService.setReturnInProgress(false);
        this.orderItemListService.toggleOrderItemVisibility(null);
        this.orderReturnControlService.emptyOrderReturnItemList();
    }

    interruptReturnProgress(): void {
        this.orderItemListService.setReturnInProgress(false);
    }

    public onPhotoInputChanged(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.returnImgSrc = e.target['result'] as string;
                this.photoLoaded = true;
            };

            reader.onloadend = (e) => {
                const imageExtension = fileInput.target.files[0].name
                    .split('.')
                    .pop()
                    .toLowerCase();
                this.setReturnPhotoImageContent(reader.result.toString(), imageExtension);
            };

            reader.readAsDataURL(fileInput.target.files[0]);
        }
    }

    public setReturnPhotoImageContent(
        imageContent: string,
        imageExtension: string
    ): void {
        this.returnPhotoImageContent = imageContent;
        this.returnPhotoImageExtension = imageExtension;
        this.photoLoaded = true;
    }

    showModifyOrderItemModal(orderItem: OrderItem): void {
        if (!this.canModifyOrderItem){
            return;
        }
        this.selectedOrderItemForModify = {
            orderItemName: orderItem.orderItemName,
            orderItemID: orderItem.orderItemID,
            quantity: orderItem.quantity,
            collectedQuantity: orderItem.collectedQuantity,
            price: orderItem.price,
            orderItemStateID: orderItem.state
        };
            this.modalRef = this._modalService.open(this._orderItemModifyModal, {
                windowClass: 'modal-holder',
                size: 'l',
                centered: true,
            });
    }

    saveOrderItem() {
        this.orderItemListService.setOrderItem(this.selectedOrderItemForModify).subscribe(() => {
            this.orderItemListService.getOrderItems(this.taskID, this.orderID);
            this.modalRef.close();
        });
    }
}
